<template>
  <div>
    
  </div>
</template>

<script>
export default {
  name: 'LessonUnitCustom',
  data () {
    return {
      name: ''
    }
  },
  created () {
    console.log('custom created')
  }
}
</script>
